<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Send a test WhatsApp
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      div.text-md.font-semibold.neutral700--text Send a test to
      template(v-for="(phone, idx) in phones")
        phone-input.mt-2(v-model="phone.number" required)
      y-button(label="Add more" outlined prepend-icon="$yzi-plus" size="sm" @click="phones.push({ number: null })")
      v-card.pa-3.round-xl.mt-4(outlined style="background-color: var(--v-neutral200);")
        div.d-flex.align-center
          v-icon.mr-2(size="18" color="neutral500" style="margin-bottom: 2px;") $yzi-alert-circle
          div.text-sm.neutral700--text Make sure you have sufficient credit balance to send test SMS.
        credit-balance.mt-2

    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="closeDialog" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(color="primary" depressed :loading="isLoading" @click="sendData") Send test

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'
import CreditBalance from '@/components/clinic/marketing/CreditBalance.vue'

export default {
  components: { PhoneInput, CreditBalance },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    blastData: {
      type: Object,
      default: (() => {})
    }
  },
  data () {
    return {
      isLoading: false,
      phones: [{ number: null }],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
        valid_email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    sendData () {
      this.isLoading = true
      this.$axios.post(`/marketing/${this.company.slug}/blasts/${this.blastData.id}/test`, { phones: this.phones.map(m => m.number) })
        .then(() => {
          this.closeDialog()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>